import axios from "axios";

export function logClick(product: string | number): void {
	let key = getCookie("clerk_store");
	let visitor = getCookie("clerk_visitor");

	if (!key || !visitor) {
		return;
	}

	axios
		.get("https://api.clerk.io/v2/log/click", {
			headers: {
				accept: "application/json",
			},
			params: {
				key: key,
				visitor: visitor,
				product: String(product),
				external: "false",
			},
		})
		.then((response) => console.log(response.data))
		.catch((error) => console.error(error));
}

function getCookie(name: any) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop()?.split(";").shift();
	return "";
}
